(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyStyleguide", [
    "localstorage",
    function (localstorage) {
      return {
        restrict: "A",
        link: function (scope, elem) {
          var $tabs = elem.find("[role=tab]");

          if (localstorage.exists("styleguide-tab")) {
            $tabs.filter("[href=#" + localstorage.get("styleguide-tab").val + "]").click();
          }

          $tabs.on("click", function () {
            var $tab = angular.element(this);
            localstorage.set("styleguide-tab", $tab.attr("href").match(/^#(.*)/)[1]);
          });
        },
      };
    },
  ]);
})(window.angular);
